module.exports = __webpack_public_path__ + "img/008.ad7b5735.jpg";